import React from "react";

export default function ApplicationUsageTable({ columns, data }) {
  return (
   <table className="w-full text-sm text-left border-collapse">
      <thead>
        <tr className="border-b bg-gray-50">
          {columns.map((col, index) => (
            <th key={index} className="px-4 py-2 font-medium text-gray-600">
              {col.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, i) => (
          <tr key={i} className="border-b hover:bg-gray-50    shadow-sm hover:shadow-md transition">
            {columns.map((col, j) => (
              <td key={j} className="px-4 py-3">
                {col.render ? col.render(row) : row[col.accessor]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
